<template>
  <div
    id="CameraVideo"
    ref="playerBoxRef"
    v-loading="loading"
    element-loading-spinner="el-icon-loading"
  >
    <div
      v-show="showMask"
      ref="iconEasyPlayRef"
      class="icon-easy-play"
      @click="onePlay"
    >
      <span class="iconfont icon-bofang easy-play-btn-bofang"></span>
    </div>
    <easy-player
      class="easyPlayer"
      ref="playerRef"
      :video-url="videoUrl"
      :aspect="aspect"
      :autoplay="easyAutoPlay"
      :decode-type="decodeType"
      :easy-stretch="easyStretch"
      :live="live"
      :muted="muted"
      :poster="easyPoster"
      :reconnection="reconnection"
      :has-audio="hasAudio"
      @play="onEasyPlay"
      @pause="onEasyPause"
      @error="onEasyError"
      @ended="onEasyEnded"
    />

    <controlBar
      v-show="controlBarShow"
      ref="controlBarRef"
      :played="played"
      :quality="quality"
      :qualityList="qualityList"
      :full="full"
      @play="onPlay"
      @pause="onPause"
      @reStart="onReStart"
      @changeQuality="onChangeQuality"
      @fullScreen="fullScreenFn"
    ></controlBar>
  </div>
</template>

<script>
import EasyPlayer from "@easydarwin/easyplayer";
import controlBar from "./components/_ControlBar.vue";
import screenFull from "screenfull";
import { iotAccess } from "@/api/request/snkd.produce";
export default {
  name: "camera-video",
  components: {
    EasyPlayer,
    controlBar,
  },
  props: {
    farmId: {
      type: [Number, String],
      default: -1,
    },
    urlOption: {
      type: Object,
      default: () => ({}),
    },
    protocolPriority: {
      type: Number,
      default: 0,
    },
    qualityPriority: {
      type: Number,
      default: 0,
    },
    aspect: {
      type: String,
      default: "16:9",
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    decodeType: {
      type: String,
      default: "auto",
    },
    easyStretch: {
      type: Boolean,
      default: true,
    },
    live: {
      type: Boolean,
      default: true,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    poster: {
      type: String,
      default: () => require("@/assets/images/video/video-poster.png"),
    },
    bigPoster: {
      type: String,
      default: () => require("@/assets/images/video/video-poster.png"),
    },
    reconnection: {
      type: Boolean,
      default: true,
    },
    hasAudio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timer: `timer-${parseInt(Math.random() * 100000)}`,
      loading: true,
      showMask: true,
      easyPoster: this.poster,
      easyAutoPlay: false,
      played: false,
      full: false,
      controlBarShow: false,

      protocol: 0, // 协议  0-HLS 1-RTMP 2-FLV
      quality: 0, // 清晰度 0-高清, 1-标清, 2-流畅
      videoUrl: "",
      qualityList: [],
    };
  },
  mounted() {},
  beforeDestroy() {
    this._destroyModule();
  },
  methods: {
    fullScreenFn() {
      if (!screenFull.isEnabled) return;
      screenFull.toggle(this.$refs.playerBoxRef);
      // if (screenFull.isFullscreen) {
      //   screenFull.exit();
      // } else {
      //   screenFull.request(this.$refs.playerBoxRef);
      // }
    },
    async onChangeQuality(quality) {
      if (this.lockQuality) return;
      this.lockQuality = true;
      this.loading = true;
      this.easyPoster = "";
      this[this.timer] && clearTimeout(this[this.timer]);

      const { value, url } = this.qualityList.find(
        (item) => item.value === quality.value
      );
      this.quality = value;
      if (Number(this.urlOption.addType) === 2) {
        this.videoUrl = url;
      } else {
        await this.initLiveUrlControl();
      }

      await this._nextTickPlayAddBtnControl(400);

      Number(this.urlOption.addType) !== 2 && this.updateLiveUrlControl();
      await this._nextTick(3799, () => {
        this.loading = false;
      });
      this.lockQuality = false;
    },
    async onReStart() {
      if (this.lockReload) return;
      this.lockReload = true;
      this.loading = true;
      this.$refs.playerRef.restartPlayer();
      await this._nextTick(10, async () => {
        await this._addControlBtn();
      });

      await this._nextTick(600, () => {
        this.loading = false;
      });
      this.lockReload = false;
    },
    onPause() {
      this._destroyModule();
    },
    onPlay() {
      // console.log('onPlay');
    },
    async onEasyEnded(e) {
      console.log("onEasyEnded", e);
      await this._nextTick(20, async () => {
        await this._addControlBtn();
      });
    },
    async onEasyError(e) {
      console.log("onEasyError", e);
      await this.onReStart();
    },
    onEasyPause(e) {
      console.log("onEasyPause", e);
    },
    onEasyPlay(e) {
      console.log("onEasyPlay", e);
    },
    async onePlay() {
      this.loading = true;
      this.easyAutoPlay = true;
      this.played = true;
      if (Number(this.urlOption.addType) !== 2) {
        this[this.timer] && clearTimeout(this[this.timer]);
        await this.initLiveUrlControl();
      }

      console.log("videoUrl", this.videoUrl);
      await this._nextTickPlayAddBtnControl();
      this.initOnFullScreen();

      Number(this.urlOption.addType) !== 2 && this.updateLiveUrlControl();
      await this._nextTick(800, () => {
        this.loading = false;
      });
    },

    async initModule() {
      this.loading = true;
      this.quality = 0;
      this.videoUrl = "";
      this.qualityList = [];
      this[this.timer] && clearTimeout(this[this.timer]);
      await this._nextTick();
      await this.initData();

      this.qualityList.length && (this.videoUrl = this.qualityList[0].url);
      (this.autoplay || this.played) && this.onePlay();
      this.loading = false;
    },
    async initData() {
      if (Number(this.urlOption.addType) === 2) {
        const { flvUrl, flvUrlHd, hlsUrl, hlsUrlHd } = this.urlOption;
        const videoUrl = flvUrl || hlsUrl;
        const videoUrlHd = flvUrlHd || hlsUrlHd;
        videoUrlHd &&
          this.qualityList.push({
            name: "高清",
            value: 0,
            url: videoUrlHd.trim(),
          });
        videoUrl &&
          this.qualityList.push({
            name: "标清",
            value: 2,
            url: videoUrl.trim(),
          });
      } else {
        if (
          this.urlOption.supportProtocols &&
          this.urlOption.supportProtocols.length
        ) {
          this.protocol = this.urlOption.supportProtocols.includes(
            this.protocolPriority
          )
            ? this.protocolPriority
            : this.urlOption.supportProtocols[0];
        }

        if (
          this.urlOption.supportQualities &&
          this.urlOption.supportQualities.length
        ) {
          this.quality = this.urlOption.supportQualities.includes(
            this.qualityPriority
          )
            ? this.qualityPriority
            : this.urlOption.supportQualities[0];
          if (this.urlOption.supportQualities.includes(0)) {
            this.qualityList.push({
              name: "高清",
              value: 0,
              url: "",
              expireSeconds: 0,
            });
          }

          if (this.urlOption.supportQualities.includes(2)) {
            this.qualityList.push({
              name: "标清",
              value: 2,
              url: "",
              expireSeconds: 0,
            });
          }
        } else {
          this.qualityList.push({
            name: "高清",
            value: 0,
            url: "",
            expireSeconds: 0,
          });
        }
      }
    },
    initOnFullScreen() {
      if (!screenFull.isEnabled) return;
      screenFull.on("change", this.onFullScreen);
    },
    destroyOnFullScreen() {
      if (!screenFull.isEnabled) return;
      screenFull.off("change", this.onFullScreen);
    },
    onFullScreen() {
      this.full = screenFull.isFullscreen;

      if (this.bigPoster !== this.poster) {
        this.easyPoster = this.full ? this.bigPoster : this.poster;
        this.$refs.iconEasyPlayRef.style.background = `url(${
          this.full ? this.bigPoster : this.poster
        }) center / 100% 100% no-repeat`;
      }
    },

    updateLiveUrlControl() {
      this[this.timer] && clearTimeout(this[this.timer]);
      const curQualityIndex = this._getCurQualityIndex(this.quality);
      if (this.qualityList[curQualityIndex].expireSeconds) {
        this[this.timer] = setTimeout(() => {
          this.getLiveUrl(this.quality).then(async (res) => {
            if (res) {
              const { videoUrl, expireSeconds } = res;
              this.qualityList[curQualityIndex].url = videoUrl;
              this.qualityList[curQualityIndex].expireSeconds = expireSeconds;
              this.videoUrl = videoUrl;

              await this._nextTick(20, async () => {
                await this._addControlBtn();
              });
              this.updateLiveUrlControl();
            }
          });
        }, this.qualityList[curQualityIndex].expireSeconds * 1000 - 2000);
      }
    },
    async initLiveUrlControl() {
      this[this.timer] && clearTimeout(this[this.timer]);
      const curQualityIndex = this._getCurQualityIndex(this.quality);
      const res = await this.getLiveUrl(this.quality);
      if (res) {
        const { videoUrl, expireSeconds } = res;
        this.qualityList[curQualityIndex].url = videoUrl;
        this.qualityList[curQualityIndex].expireSeconds = expireSeconds;
        this.videoUrl = videoUrl;
      }
    },
    async getLiveUrl(quality) {
      try {
        const res = await iotAccess.getLiveUrlService({
          farmId: this.farmId,
          cameraId: this.urlOption.cameraId,
          protocol: this.protocol,
          quality,
        });
        if (res) {
          return res.liveVideo;
        }
      } catch (err) {
        return null;
      }
    },

    async _nextTickPlayAddBtnControl(playTime = 300, btnTime = 20) {
      await this._nextTick(playTime, async () => {
        if (Number(this.urlOption.addType) === 2) {
          this.$refs.playerRef.initPlayer();
        } else {
          this.$refs.playerRef.play();
        }
        this.showMask = false;
      });
      await this._nextTick(btnTime, async () => {
        await this._addControlBtn();
      });
    },
    _addControlBtn() {
      if (
        this.$refs.playerRef.$el.children[0].children[0].className ===
        "no-single"
      ) {
        return this._nextTick(800, () => {
          this._destroyModule();
        });
      }
      this.$refs.playerRef.$el.children[0].children[0].children[6].appendChild(
        this.$refs.controlBarRef.$refs.playBtnRef
      );
      this.$refs.playerRef.$el.children[0].children[0].children[6].appendChild(
        this.$refs.controlBarRef.$refs.reStartBtnRef
      );
      this.$refs.playerRef.$el.children[0].children[0].children[6].appendChild(
        this.$refs.controlBarRef.$refs.qualityBtnRef
      );
      this.$refs.playerRef.$el.children[0].children[0].children[6].appendChild(
        this.$refs.controlBarRef.$refs.fullScreenBtnRef
      );
    },
    _destroyModule() {
      this.showMask = true;
      if (this.$refs.playerRef) {
        this.easyAutoPlay = false;
        this.played = false;
        this.$refs.playerRef.destroyPlayer();
        !(this.full && !this.played) && this.destroyOnFullScreen();
      }
      this[this.timer] && clearTimeout(this[this.timer]);
      this[this.timer] = null;
    },
    _getCurQualityIndex(quality) {
      return this.qualityList.findIndex((item) => item.value === quality);
    },
    _isURL(str_url) {
      const re =
        // eslint-disable-next-line no-useless-escape
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      if (re.test(str_url)) {
        return true;
      } else {
        return false;
      }
    },
    _getMilliseconds(expireSeconds) {
      return expireSeconds ? expireSeconds * 1000 - 3000 : 0;
    },
    _nextTick(time = 0, cb = () => {}) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          await this.$nextTick();
          await cb();
          resolve(true);
        }, time);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#CameraVideo {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url("~@/assets/images/video/video-poster.png") center no-repeat;
  background-size: 100% 100%;
  .icon-easy-play {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("~@/assets/images/video/video-poster.png") center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    & > .iconfont {
      font-size: 24px;
      color: #fff;
      margin-top: -5.5%;
    }
  }
  ::v-deep.easyPlayer {
    cursor: pointer;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    .easy-player-loading {
      z-index: 1999;
      & > img {
        display: none !important;
      }
      & > .loading-text {
        background-image: -webkit-linear-gradient(
          left,
          #1890ff,
          #fff 25%,
          #1890ff 50%,
          #fff 75%,
          #1890ff
        ) !important;
      }
    }
    .easy-play-btn {
      top: 45% !important;
      transform: translate(-50%, -50%);
    }
    .vjs-control-bar {
      .vjs-live-control,
      .vjs-play-control,
      .vjs-volume-panel,
      .vjs-bitrate-control,
      .vjs-stretch-control,
      .vjs-snapshot-control,
      .icon-luxiang2,
      .vjs-progress-control,
      .vjs-time-control,
      .vjs-fullscreen-control {
        display: none !important;
      }
    }

    .easy-video-player-inner {
      .video-js > video {
        height: 100% !important;
      }
    }
  }

  & > ::v-deep.el-loading-mask {
    background-color: rgba(0, 0, 0, 0.4) !important;
    .el-loading-spinner {
      margin-top: -55px !important;
      .el-icon-loading {
        font-size: 50px !important;
        color: rgba(24, 144, 255, 0.8) !important;
      }
    }
  }
}
</style>
